export const HEALTH_PROBLEMS = [
  "Obesidade",
  "Sobrepeso",
  "Resistência à insulina",
  "Pré-diabetes",
  "Diabetes tipo 2",
  "Hipotireoidismo",
  "Hipertireoidismo",
  "Síndrome dos ovários policísticos (SOP)",
  "Colesterol alto (dislipidemia)",
  "Triglicerídeos altos",
  "Esteatose hepática (gordura no fígado)",
  "Hipertensão",
  "Hipotensão",
  "Arritmia",
  "Insuficiência cardíaca",
  "Doença arterial coronariana",
  "Asma",
  "Rinite alérgica",
  "Sinusite crônica",
  "Apneia do sono",
  "Refluxo gastroesofágico (DRGE)",
  "Gastrite",
  "Síndrome do intestino irritável",
  "Constipação (intestino preso)",
  "Doença celíaca",
  "Intolerância à lactose",
  "Ansiedade",
  "Depressão",
  "Compulsão alimentar",
  "Transtorno de pânico",
  "Estresse crônico",
  "Dor lombar crônica",
  "Enxaqueca",
  "Fibromialgia",
  "Artrose",
  "Artrite reumatoide",
  "Insônia",
  "Sonolência diurna excessiva",
  "Fadiga crônica",
  "Anemia",
  "Deficiência de vitamina D",
  "Tabagismo",
  "Sedentarismo",
];

export const GENDER_OPTIONS = [
  { value: "", label: "Selecionar" },
  { value: "Feminino", label: "Feminino" },
  { value: "Masculino", label: "Masculino" },
];

export const AGE_OPTIONS = [
  { value: "", label: "Selecionar" },
  { value: "18-25", label: "18 a 25 anos" },
  { value: "26-35", label: "26 a 35 anos" },
  { value: "36-45", label: "36 a 45 anos" },
  { value: "46-52", label: "46 a 52 anos" },
  { value: "53-60", label: "53 a 60 anos" },
  { value: "61-70", label: "61 a 70 anos" },
  { value: "70+", label: "Mais de 70 anos" },
];